<template>
    <div class="card">
        <div class="card-header">
            Total em caixa
        </div>

        <div class="card-body">
            <div class="text-center">
                <h2>R$ {{cashRegister.value}} </h2>

                <ul class="text-left list-unstyled" style="font-size: 0.9rem;" >
                    <li>R$ {{cashRegister.initValue}} Valor de abertura</li>
                    <li>R$ {{cashRegister.avistaValue}} Valor total a vista</li>
                    <li>R$ {{cashRegister.aprazoValue}} Valor total a prazo</li>
                    <li>R$ {{cashRegister.cancelValue}} Valor total cancelado</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'vwCashRegister',
    data(){
        return {
            cashRegister: {
                value: 0,
                initValue: 0,
                cancelValue: 0,
                avistaValue: 0,
                aprazoValue: 0
            }
        }
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    methods: {
        getData: function(){
            fetch(server + 'informacoes/caixa'+this.getToken, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.response[0]

                    if(responseJSON.data.length > 0){
                        this.cashRegister.value         = data.SALDO_DO_CAIXA
                        this.cashRegister.initValue     = data.SALDO_ABERTURA_CAIXA
                        this.cashRegister.cancelValue   = data.TOTAL_CANCELADOS
                        this.cashRegister.avistaValue   = data.TOTAL_AVISTA
                        this.cashRegister.aprazoValue   = data.TOTAL_APRAZO
                    }
                })
                .catch(error => {
                    console.log('Error', '=>', error)
                })
        }
    },
    mounted(){
        this.getData()
    }
}
</script>